<p-dialog
  [header]="dialogHeaderKey | translate"
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="!saving"
  [closable]="!saving"
  styleClass="report-mixture-card-dialog eko-responsive-dialog"
  [style]="{ width: 'min(40rem, 94vw)' }"
>
  <form [formGroup]="form" class="report-mixture-card-form">
    <div class="field">
      <label for="mixture-name" class="field-label">
        {{ 'reports.fill.mixtureDialog.name' | translate }}<span class="text-required">*</span>
      </label>
      <input
        id="mixture-name"
        type="text"
        pInputText
        formControlName="name"
        class="w-full"
        autocomplete="off"
        maxlength="100"
      />
      @if (fieldError('name')) {
        <small class="p-error">{{ fieldError('name') }}</small>
      }
    </div>

    <div class="field">
      <label for="mixture-mass" class="field-label">
        {{ 'reports.fill.mixtureDialog.massKg' | translate }}<span class="text-required">*</span>
      </label>
      <p-inputNumber
        inputId="mixture-mass"
        formControlName="mass"
        [min]="0"
        [maxFractionDigits]="8"
        [minFractionDigits]="0"
        mode="decimal"
        styleClass="mixture-mass-input"
      />
      @if (fieldError('mass')) {
        <small class="p-error">{{ fieldError('mass') }}</small>
      }
    </div>

    <div class="field">
      <span id="mixture-type-label" class="field-label">
        {{ 'reports.fill.mixtureDialog.type' | translate }}<span class="text-required">*</span>
      </span>
      <p-selectButton
        formControlName="mixtureType"
        [options]="mixtureTypeOptions"
        optionLabel="label"
        optionValue="value"
        [fluid]="true"
        [allowEmpty]="false"
        [disabled]="isEditMode || saving"
        aria-labelledby="mixture-type-label"
        styleClass="mixture-type-select"
      />
    </div>

    <div class="field">
      <label for="mixture-description" class="field-label">{{ 'reports.fill.mixtureDialog.description' | translate }}</label>
      <textarea
        id="mixture-description"
        pTextarea
        formControlName="description"
        class="w-full"
        rows="4"
        [autoResize]="true"
      ></textarea>
    </div>

    @if (isWeldingSectionVisible) {
      <div class="mixture-welding-section">
        <h3 class="mixture-welding-heading">{{ 'reports.fill.mixtureDialog.weldingSectionTitle' | translate }}</h3>
        <div class="mixture-welding-grid">
          @for (key of weldingFieldKeys; track key) {
            <div class="field mixture-welding-field">
              <label [attr.for]="'mixture-weld-' + key" class="field-label">
                {{ weldingFieldLabel(key) | translate }}<span class="text-required">*</span>
              </label>
              <div class="mixture-welding-input-row">
                <input
                  [id]="'mixture-weld-' + key"
                  pInputText
                  [formControlName]="key"
                  class="w-full"
                  inputmode="decimal"
                  autocomplete="off"
                />
                <span class="mixture-welding-suffix">%</span>
              </div>
              @if (fieldError(key)) {
                <small class="p-error">{{ fieldError(key) }}</small>
              }
            </div>
          }
        </div>
      </div>
    }
  </form>

  <ng-template pTemplate="footer">
    <div class="report-mixture-card-footer">
      <p-button
        type="button"
        [label]="'reports.dialog.save' | translate"
        [loading]="saving"
        [disabled]="saving || form.invalid"
        (onClick)="onSave()"
      />
    </div>
  </ng-template>
</p-dialog>
